// -----------------------------------------------------------
// FloraIQ - Painel de etapa do fluxo operacional
// -----------------------------------------------------------
// Mostra a definicao da etapa (objetivo e itens que ela deve cumprir).
// O andamento real por etapa ainda nao tem fonte de dados.

import type { ReactNode } from "react";
import { NoRealData } from "@/components/shared";
import type { OperationalStageDef } from "@/config/relat-oper-ladm-operacional-config";

interface Props {
  stage: OperationalStageDef;
  /** Conteudo real ou especifico da etapa (ex.: missoes de campo). */
  children?: ReactNode;
  /** Texto do aviso de ausencia de dado de execucao; null oculta o aviso. */
  noDataDescription?: string | null;
}

export default function StageMethodologyPanel({ stage, children, noDataDescription }: Props) {
  return (
    <div className="space-y-5">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
          <i className={`${stage.icon} text-accent-600`}></i>
        </div>
        <div>
          <h4 className="text-sm font-bold text-foreground-900">Etapa {stage.id} — {stage.nome}</h4>
          <p className="text-xs text-foreground-500 mt-0.5 max-w-3xl">{stage.objetivo}</p>
        </div>
      </div>

      {stage.checklist.length > 0 && (
        <div>
          <h5 className="text-xs font-semibold text-foreground-700 mb-2">Itens previstos na etapa</h5>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-1.5">
            {stage.checklist.map((item) => (
              <li key={item} className="flex items-start gap-2 p-2 rounded-lg bg-background-50/70 border border-background-100/70 text-xs text-foreground-700">
                <i className="ri-checkbox-blank-circle-line text-foreground-300 mt-0.5"></i>
                {item}
              </li>
            ))}
          </ul>
        </div>
      )}

      {children}

      {noDataDescription !== null && (
        <NoRealData
          icon="ri-progress-3-line"
          title={`Andamento da etapa ${stage.nome}`}
          description={
            noDataDescription ??
            "Aqui aparecerão o progresso, os responsáveis, os prazos e as pendências desta etapa. Ainda não há registro de execução por etapa no sistema."
          }
        />
      )}
    </div>
  );
}
